import axios from 'axios'

export function fetchRentalSuppliers() {
  return axios.get('/rental-suppliers')
}
